import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { profilData } from '../data/adminData';
import { FaSave, FaEdit, FaPlus, FaTrash, FaArrowLeft } from 'react-icons/fa';

const KelolaProfil = () => {
    const { section } = useParams();
    const [data, setData] = useState(profilData);
    const [editing, setEditing] = useState(false);

    const handleSave = () => {
        setEditing(false);
        alert('Data berhasil disimpan!');
    };

    const renderVisiMisi = () => (
        <div className="space-y-6">
            <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold text-[#0F172A]">Visi</h3>
                    <button onClick={() => setEditing(!editing)} className="text-[#0D9488] hover:text-[#0F766E]">
                        <FaEdit className="mr-1 inline" /> Edit
                    </button>
                </div>
                {editing ? (
                    <textarea
                        defaultValue={data.visiMisi.visi}
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]"
                        rows="4"
                    />
                ) : (
                    <p className="text-gray-700">{data.visiMisi.visi}</p>
                )}
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm">
                <h3 className="text-lg font-bold text-[#0F172A] mb-4">Misi</h3>
                <ul className="space-y-3">
                    {data.visiMisi.misi.map((item, index) => (
                        <li key={index} className="flex items-start">
                            <span className="w-6 h-6 bg-[#0D9488] text-white rounded-full flex items-center justify-center text-sm mr-3 flex-shrink-0 mt-0.5">
                                {index + 1}
                            </span>
                            {editing ? (
                                <input
                                    defaultValue={item}
                                    className="flex-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]"
                                />
                            ) : (
                                <span className="text-gray-700">{item}</span>
                            )}
                        </li>
                    ))}
                </ul>
                {editing && (
                    <button className="mt-4 text-[#0D9488] hover:text-[#0F766E] text-sm">
                        <FaPlus className="inline mr-1" /> Tambah Misi
                    </button>
                )}
            </div>

            {editing && (
                <div className="flex justify-end">
                    <button onClick={handleSave} className="btn-primary flex items-center">
                        <FaSave className="mr-2" /> Simpan Perubahan
                    </button>
                </div>
            )}
        </div>
    );

    const renderStruktur = () => (
        <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-bold text-[#0F172A]">Struktur Organisasi</h3>
                <button className="btn-primary text-sm">
                    <FaPlus className="mr-1 inline" /> Tambah Pejabat
                </button>
            </div>
            <div className="space-y-3">
                {data.strukturOrganisasi.map((item) => (
                    <div key={item.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100">
                        <div>
                            <p className="font-semibold text-gray-700">{item.jabatan}</p>
                            <p className="text-sm text-gray-500">{item.nama} - NIP. {item.nip}</p>
                        </div>
                        <div className="flex space-x-2">
                            <button className="text-blue-500 hover:text-blue-700">
                                <FaEdit />
                            </button>
                            <button className="text-red-500 hover:text-red-700">
                                <FaTrash />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    const renderStandarPelayanan = () => (
        <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-bold text-[#0F172A]">Standar Pelayanan</h3>
                <button className="btn-primary text-sm">
                    <FaPlus className="mr-1 inline" /> Tambah Standar
                </button>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead>
                        <tr className="bg-gray-50 text-left text-sm">
                            <th className="p-3">Layanan</th>
                            <th className="p-3">Persyaratan</th>
                            <th className="p-3">Waktu</th>
                            <th className="p-3">Biaya</th>
                            <th className="p-3">Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.standarPelayanan.map((item) => (
                            <tr key={item.id} className="border-b">
                                <td className="p-3 font-medium">{item.layanan}</td>
                                <td className="p-3 text-sm">{item.persyaratan}</td>
                                <td className="p-3 text-sm">{item.waktu}</td>
                                <td className="p-3 text-sm">{item.biaya}</td>
                                <td className="p-3">
                                    <button className="text-blue-500 hover:text-blue-700 mr-2"><FaEdit /></button>
                                    <button className="text-red-500 hover:text-red-700"><FaTrash /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );

    const renderKontak = () => (
        <div className="bg-white rounded-xl p-6 shadow-sm">
            <h3 className="text-lg font-bold text-[#0F172A] mb-6">Informasi Kontak</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {Object.entries(data.kontak).map(([key, value]) => (
                    <div key={key}>
                        <label className="block text-sm font-medium text-gray-700 capitalize mb-2">
                            {key.replace(/([A-Z])/g, ' $1').trim()}
                        </label>
                        <input
                            defaultValue={value}
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]"
                        />
                    </div>
                ))}
            </div>
            <div className="flex justify-end mt-6">
                <button onClick={handleSave} className="btn-primary flex items-center">
                    <FaSave className="mr-2" /> Simpan Perubahan
                </button>
            </div>
        </div>
    );

    const renderContent = () => {
        switch (section) {
            case 'visi-misi': return renderVisiMisi();
            case 'tupoksi': return renderVisiMisi(); // Bisa dibuat serupa
            case 'struktur': return renderStruktur();
            case 'standar-pelayanan': return renderStandarPelayanan();
            case 'kontak': return renderKontak();
            default: return renderVisiMisi();
        }
    };

    return (
        <div>
            <div className="flex items-center mb-6">
                <button onClick={() => window.history.back()} className="mr-4 text-gray-500 hover:text-gray-700">
                    <FaArrowLeft />
                </button>
                <h2 className="text-2xl font-bold text-[#0F172A] capitalize">
                    Kelola {section?.replace('-', ' ') || 'Profil'}
                </h2>
            </div>
            {renderContent()}
        </div>
    );
};

export default KelolaProfil;